import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'sz-brand-block',
  templateUrl: './sz-brand-block.component.html',
  styleUrls: ['./sz-brand-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzBrandBlockComponent {
  readonly tagline: InputSignal<string | null> = input<string | null>(null);
  readonly compact: InputSignal<boolean> = input<boolean>(false);
}
